export const REACT_APP_PUBLIC_DIRECTUS_API: string = "https://ftx-pay.futurix.xyz"
export const REACT_CASHOUT_PUBLIC_DIRECTUS_API: string = "https://documenter.getpostman.com/view/17461446/2sA35HXLni"
export const USER_COLLECTION_NAME: string = "users"
export const operatorPrefixes = {
    'ONATEL': [
        "01", "02", "03", "50", "51", "52", "53", "60", "61", "62", "63", "70", "71", "72", "73"
    ],
    'ORANGE': [
        "05", "06", "07", "54", "55", "56", "57", "64", "65", "66", "67", "74", "75", "76", "77"
    ],
    'TELECEL': ["58", "68", "69", "78", "79"],
};
export const isValidPrefix = (phone: string) => {
    const prefix = phone.slice(0, 2);
    return Object.values(operatorPrefixes).some((prefixList) => prefixList.includes(prefix));
};



export type ReloadModel = {
    id: string
    montant: number
    nom: string,
    numero_commercial: string,
    date_created: string,
}
